// extracted by mini-css-extract-plugin
export default {"Grid":"ReferralDashboard_Grid__41cdE","Item":"ReferralDashboard_Item__qA0re"};